import React from "react"
import PropTypes from "prop-types"
import EnumFilter from "app/static/frontend/search-new/components/Filter/EnumFilter/EnumFilter"
import EnumFilterItem from "app/static/frontend/search-new/components/Filter/EnumFilter/EnumFilterItem"
import EnumGroupHeader from "app/static/frontend/search-new/components/Filter/EnumFilter/EnumGroupHeader"
import { SelectSearchBar as StyledSelectWrapper } from "quorumdesign"

export class CompositeEnumFilter extends React.Component {
    static propTypes = {
        ...EnumFilter.propTypes,
    }

    static defaultProps = {
        ...EnumFilter.defaultProps,
    }

    isItemActive = (itemId) => {
        if (!this.props.deserializedValue) {
            return false
        }

        const item = this.props.enumItems.find((item) => item.id === itemId || item.value === itemId)
        if (!item) return false

        const itemValue = item.value

        if (Array.isArray(this.props.deserializedValue)) {
            if (Array.isArray(itemValue)) {
                return itemValue.some((val) => this.props.deserializedValue.includes(val))
            }
            return this.props.deserializedValue.includes(itemValue)
        }
        return this.props.deserializedValue === itemValue
    }

    updateEnumFilter = (id) => {
        if (!this.props.multi) {
            const newVal = this.isItemActive(id) ? [] : [id]
            if (this.props.isNullable) {
                return this.props.publishChange(newVal)
            }
            if (newVal.length) {
                return this.props.publishChange(newVal)
            }
        } else {
            const item = this.props.enumItems.find((item) => item.id === id || item.value === id)
            if (!item) return

            const itemValue = item.value

            if (this.isItemActive(id)) {
                const deselectItem = (idNew) => {
                    if (Array.isArray(idNew)) {
                        return this.props.deserializedValue.filter((val) => !idNew.includes(val))
                    }
                    return this.props.deserializedValue.filter((val) => val !== idNew)
                }
                return this.props.publishChange(deselectItem(itemValue))
            } else {
                const selectItem = (idNew) => {
                    const currentValues = this.props.deserializedValue || []
                    if (Array.isArray(idNew)) {
                        return [...currentValues, ...idNew]
                    }
                    return [...currentValues, idNew]
                }
                return this.props.publishChange(selectItem(itemValue))
            }
        }
    }

    updateSelect = (data) => {
        if (!data) {
            this.props.publishChange(undefined)
            return
        }
        const formattedData = this.props.multi ? data.map((obj) => obj.id) : [data.id]
        this.props.publishChange(formattedData)
    }

    renderEnumInline = (item) => {
        const label = (item[this.props.displayKey] || item.label).toString()
        if (
            this.props.searchFilterTerm &&
            label &&
            label.toLowerCase().includes(this.props.searchFilterTerm.toLowerCase())
        ) {
            if (this.props.setFilterGroupContainsSearchFilterTerm) {
                this.props.setFilterGroupContainsSearchFilterTerm(true)
            }
            if (this.props.setFilterContainsSearchFilterTerm) {
                this.props.setFilterContainsSearchFilterTerm(true)
            }
        }

        return (
            <EnumFilterItem
                key={item.value}
                id={item.value}
                onPressItem={this.updateEnumFilter}
                label={label}
                helpText={this.props.useTip && item.tip}
                isActive={this.isItemActive(item.value)}
                multi={this.props.multi}
                searchFilterTerm={this.props.searchFilterTerm}
            />
        )
    }

    renderEnums = (sortedItems) => {
        return sortedItems.map(this.renderEnumInline)
    }

    renderSelect = (sortedItems) => {
        const SelectComponent = this.props.selectComponent
        return (
            <StyledSelectWrapper>
                <SelectComponent
                    value={this.props.deserializedValue}
                    onChange={this.updateSelect}
                    multi={this.props.multi}
                    customOptions={sortedItems}
                    placeholder={this.props.placeholder}
                />
            </StyledSelectWrapper>
        )
    }

    render() {
        const sortedItems = this.props.sortBy ? this.props.enumItems.sort(this.props.sortBy) : this.props.enumItems
        return this.props.selectComponent && this.props.enumItems.length >= 4 ? (
            this.renderSelect(sortedItems)
        ) : (
            <div>{sortedItems && this.renderEnums(sortedItems)}</div>
        )
    }
}

export default CompositeEnumFilter
